export enum UserRole {
  Admin = 'Admin',
  ReportsAll = 'Reports.All',
  NagcoMaintainer = 'Nagco.Maintainer',
  NagcoView = 'Nagco.View',
  NagcoReceiptUnder5000 = 'NAGCO.Receipt.Under5000',
  NagcoReceiptAll = 'Nagco.Receipt.All',
}

export const hasRole = (userRoles: string[], ...requiredRoles: UserRole[]): boolean => {
  return requiredRoles.some(role => userRoles.includes(role));
};
